import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "counter__info-value" }
const _hoisted_2 = { class: "counter__info-description" }
const _hoisted_3 = { class: "add-count__info" }
const _hoisted_4 = { class: "add-count__text" }

import { eventBus } from "@/helpers/eventBus";
  import { priceFormat } from "@/helpers/priceFormat";
  import { IProduct } from "@/models/models";
  import { onMounted, onUnmounted, PropType, ref } from "vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ChangeBasket',
  props: {
    source: {
      type: Object as PropType<IProduct> | null,
      required: true,
    },
  },
  setup(__props) {

  const props = __props;

  const changeBasket = ref(null as unknown as HTMLElement);

  const counter = ref(null as unknown as HTMLElement);

  const count = ref<number>(1 as number);

  const basket = ref<Array<IProduct>>([] as Array<IProduct>);

  const isAddCount = ref<boolean>(false as boolean);

  const addCountInput = ref(null as unknown as HTMLElement);

  const onShowAddCount = () => {
    isAddCount.value = true;

    basket.value.forEach((basketItem) => {
      if (basketItem.id == props.source.id) {
        count.value = basketItem.count;
      }
    });

    setTimeout(() => {
      addCountInput.value.focus();
    }, 100);
  };

  const handleEnter = () => {
    isAddCount.value = false;

    basket.value.forEach((basketItem) => {
      if (basketItem.id == props.source.id) {
        basketItem.count = count.value != 0 ? count.value : 1;
      }
    });

    localStorage.setItem("basket", JSON.stringify(basket.value));

    eventBus.emit("cart-updated", {});
  };

  const updateCart = () => {
    basket.value = JSON.parse(localStorage.getItem("basket") || "[]");
    if (basket.value.length != 0) {
      basket.value.forEach((basketItem) => {
        if (basketItem.id == props.source.id) {
          if (basketItem.count == 0) {
            props.source.count = 0;
          } else {
            props.source.count = basketItem.count;
          }
        }
      });
    } else {
      if (basket.value.length != 0) {
        basket.value = basket.value.filter(
          (basketItem) => basketItem.id != props.source.id
        );
      }
    }
  };

  const deleteCart = (card: IProduct) => {
    if (card.id == props.source.id) {
      props.source.count = 0;
    }
  };

  const clearCart = () => {
    props.source.count = 0;
  };

  const handleClickOutside = (event: any) => {
    if (changeBasket.value && !changeBasket.value.contains(event.target)) {
      if (isAddCount.value) {
        basket.value.forEach((basketItem) => {
          if (basketItem.id == props.source.id) {
            basketItem.count = count.value != 0 ? count.value : 1;
          }
        });

        localStorage.setItem("basket", JSON.stringify(basket.value));

        eventBus.emit("cart-updated", {});
      }
      isAddCount.value = false;
    }

    if (event.target.classList.contains("counter__btn")) {
      isAddCount.value = false;
    }
  };

  onMounted(() => {
    updateCart();
    eventBus.on("delete-card", deleteCart);
    eventBus.on("cart-clear", clearCart);
    eventBus.on("cart-updated", updateCart);
    document.addEventListener("click", handleClickOutside);
  });

  onUnmounted(() => {
    eventBus.off("delete-card", deleteCart);
    eventBus.off("cart-clear", clearCart);
    eventBus.off("cart-updated", updateCart);
    document.removeEventListener("click", handleClickOutside);
  });

  const onAddBasket = () => {
    basket.value = JSON.parse(localStorage.getItem("basket") || "[]");
    // changeBasket.value.classList.add("change-basket--active");
    // counter.value.classList.add("counter--active");

    props.source.count = count.value;

    basket.value.push(props.source);

    localStorage.setItem("basket", JSON.stringify(basket.value));

    eventBus.emit("cart-updated", {});
  };

  const onChangeCount = (value: string) => {
    basket.value = JSON.parse(localStorage.getItem("basket") || "[]");
    if (value == "minus") {
      props.source.count--;
      if (props.source.count == 0) {
        // changeBasket.value?.classList.remove("change-basket--active");
        // counter.value?.classList.remove("counter--active");

        if (basket.value.length != 0) {
          basket.value = basket.value.filter(
            (basketItem) => basketItem.id != props.source.id
          );
        }
      } else {
        if (basket.value.length != 0) {
          basket.value.forEach((basketItem) => {
            if (basketItem.id == props.source.id) {
              basketItem.count = props.source.count;
            }
          });
        }
      }
    } else {
      if (basket.value.length != 0) {
        props.source.count++;
        basket.value.forEach((basketItem) => {
          if (basketItem.id == props.source.id) {
            basketItem.count = props.source.count;
          }
        });
      }
    }
    localStorage.setItem("basket", JSON.stringify(basket.value));

    eventBus.emit("cart-updated", {});
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "changeBasket",
    ref: changeBasket,
    class: _normalizeClass(["change-basket", { 'change-basket--active': props.source.count }])
  }, [
    _createElementVNode("button", {
      onClick: onAddBasket,
      class: "btn btn--green change-basket__btn",
      type: "button"
    }),
    _createElementVNode("div", {
      ref_key: "counter",
      ref: counter,
      class: _normalizeClass([{ 'counter--active': props.source.count }, "counter"])
    }, [
      _createElementVNode("button", {
        class: "btn btn--green counter__btn counter__btn--minus",
        type: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (onChangeCount('minus')))
      }),
      _createElementVNode("div", {
        class: "counter__info",
        onClick: onShowAddCount
      }, [
        _createElementVNode("div", _hoisted_1, _toDisplayString(__props.source.count) + " шт", 1),
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(priceFormat)(__props.source.count * __props.source.basePrice)), 1)
      ]),
      _createElementVNode("button", {
        class: "btn btn--green counter__btn counter__btn--plus",
        type: "button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (onChangeCount('plus')))
      })
    ], 2),
    _withDirectives(_createElementVNode("div", {
      class: "add-count",
      ref: "addCount",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (addCountInput.value.focus()))
    }, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "add-count__title" }, "Введите количество", -1)),
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          type: "number",
          ref_key: "addCountInput",
          ref: addCountInput,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((count).value = $event)),
          onKeyup: _withKeys(handleEnter, ["enter"])
        }, null, 544), [
          [_vModelText, count.value]
        ]),
        _createElementVNode("span", _hoisted_4, _toDisplayString(count.value) + " шт", 1)
      ])
    ], 512), [
      [_vShow, isAddCount.value]
    ])
  ], 2))
}
}

})